// 읽지 않은 알림 큐(폴링 30초) + 읽음 처리(독립).
import { useState, useEffect } from 'react';
import { chatAPI } from '../../../api/client';

export default function useNotifications() {
  const [notifications, setNotifications] = useState([]);  // 읽지 않은 알림 큐

  const fetchNotifications = () => {
    chatAPI.getNotifications().then((r) => {
      if (r.data.length > 0) setNotifications(r.data);
    }).catch(() => {});
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const dismissNotification = async (id) => {
    await chatAPI.readNotification(id).catch(() => {});
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  return { notifications, dismissNotification };
}
